import React from 'react';

const IconsMap = ({ iconKey }) => {
  const renderIcon = () => {
    switch (iconKey) {
      case 'TABLE':
        return (
          <svg
            aria-label='Table'
            aria-hidden='true'
            data-testid='TableIcon'
            role='img'
            viewBox='0 0 16 16'
            height='16'
            width='16'>
            <path
              fill='currentColor'
              d='M14,2.22710739e-16 L2,2.22710739e-16 C0.896798134,0.00329480111 0.00329480111,0.896798134 0,2 L0,14 C0.00329480111,15.1032019 0.896798134,15.9967052 2,16 L14,16 C15.1032019,15.9967052 15.9967052,15.1032019 16,14 L16,2 C15.9967052,0.896798134 15.1032019,0.00329480111 14,2.22710739e-16 Z M6,8 L10,8 L10,11 L6,11 L6,8 Z M5,11 L1,11 L1,8 L5,8 L5,11 Z M6,7 L6,4 L10,4 L10,7 L6,7 Z M5,7 L1,7 L1,4 L5,4 L5,7 Z M6,15 L6,12 L10,12 L10,15 L6,15 Z M15,14 C15,14.5522847 14.4030463,15 13.6666667,15 L11,15 L11,12 L15,12 L15,14 Z M1,14 L1,12 L5,12 L5,15 L2.33333333,15 C1.59695367,15 1,14.5522847 1,14 Z M15,11 L11,11 L11,8 L15,8 L15,11 Z M15,7 L11,7 L11,4 L15,4 L15,7 Z M12,3 L1,3 L1,2 C1,1.44771525 1.44771525,1 2,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,3 L12,3 Z'></path>
          </svg>
        );
      case 'TIME':
        return (
          <svg
            aria-label='Time'
            aria-hidden='true'
            data-testid='TrendIcon'
            role='img'
            viewBox='0 0 16 16'
            height='16'
            width='16'>
            <path
              fill='currentColor'
              d='M15.5,15H15V7H11v8H10V10H6v5H5V9H1v6H.5a.5.5,0,0,0,0,1h15a.5.5,0,0,0,0-1ZM4,15H2V10H4Zm5,0H7V11H9Zm5,0H12V8h2Z'></path>
            <path
              fill='currentColor'
              d='M1.859,6.828,4.982,4.5,6.89,7.688a.509.509,0,0,0,.04.062L7,7.859a.5.5,0,0,0,.707,0l.009-.014L14,1.664V4.5a.5.5,0,0,0,1,0V.5l0-.011a.5.5,0,0,0-.037-.18A.5.5,0,0,0,14.9.215a.468.468,0,0,0-.045-.068.461.461,0,0,0-.039-.026.5.5,0,0,0-.125-.083.491.491,0,0,0-.079-.016A.475.475,0,0,0,14.5,0h-4a.5.5,0,0,0,0,1h2.744L7.429,6.719,5.525,3.54a.492.492,0,0,0-.111-.176.5.5,0,0,0-.709,0l0,.005L1.152,6.121a.5.5,0,0,0,.707.707Z'></path>
          </svg>
        );
      case 'BAR':
        return (
          <svg
            aria-label='Bar'
            aria-hidden='true'
            data-testid='HorizontalBarChartIcon'
            role='img'
            viewBox='0 0 16 16'
            height='16'
            width='16'>
            <path
              fill='currentColor'
              d='M1,.5V1H14V4H1V6H11V9H1v2H8v3H1v1H15.5a.5.5,0,0,1,0,1H.5a.5.5,0,0,1-.5-.5V.5a.5.5,0,0,1,1,0ZM1,13H7V12H1ZM1,8h9V7H1ZM1,3H13V2H1Z'></path>
          </svg>
        );
      case 'COMPARE':
        return (
          <svg
            aria-label='Compare'
            aria-hidden='true'
            data-testid='ComparisonChartIcon'
            role='img'
            viewBox='0 0 16 16'
            height='16'
            width='16'
            class='sc-1d4iol7-0 fSiweQ'>
            <path
              fill='currentColor'
              d='M6.5,16H.5a.5.5,0,0,1-.5-.5V3a.5.5,0,0,1,.5-.5h6A.5.5,0,0,1,7,3V15.5A.5.5,0,0,1,6.5,16ZM1,15H6V3.5H1Z'></path>
            <path
              fill='currentColor'
              d='M15.5,16h-6a.5.5,0,0,1-.5-.5V3a.5.5,0,0,1,.5-.5h6A.5.5,0,0,1,16,3V15.5A.5.5,0,0,1,15.5,16ZM10,15h5V3.5H10Z'></path>
            <path fill='currentColor' d='M15.5,1H.5a.5.5,0,0,1,0-1h15a.5.5,0,0,1,0,1Z'></path>
          </svg>
        );

      default:
        return null;
    }
  };
  return renderIcon();
};
export default IconsMap;
